import type { Element } from 'react'
import React, { Component } from 'react'
import { SwitchButton } from './SwitchButton'
import styled from 'styled-components'
import { media, ResponsiveContainer } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'

const { tertiary } = colors

type Props = {
    activeLeft: boolean,
    leftBlock: Element<any>,
    rightBlock?: Element<any>,
    idTitleLeft: string,
    idTitleRight: string,
    valuesTitleLeft?: {},
    valuesTitleRight?: {},
    className?: string
}

type State = {
    toggleTab: boolean
}

class SplitLayout extends Component<Props, State> {
    constructor(props: Props) {
        super()
        this.state = {
            toggleTab: props.activeLeft
        }
    }

    leftFocus = () => this.setState({ toggleTab: true })

    rightFocus = () => this.setState({ toggleTab: false })

    render() {
        const {
            idTitleLeft,
            idTitleRight,
            leftBlock,
            rightBlock,
            valuesTitleLeft,
            valuesTitleRight,
            className
        } = this.props
        const { toggleTab } = this.state
        return (
            <StyledResponsiveContainer className={className}>
                <SwitchContainer className={className} right={!toggleTab}>
                    <SwitchButton
                        labelKey={idTitleLeft}
                        labelValues={valuesTitleLeft}
                        active={toggleTab}
                        handleClick={this.leftFocus}
                    />
                    <SwitchButton
                        labelKey={idTitleRight}
                        labelValues={valuesTitleRight}
                        active={!toggleTab}
                        handleClick={this.rightFocus}
                    />
                </SwitchContainer>
                {toggleTab ? (
                    <Block className={className}>{leftBlock}</Block>
                ) : (
                    <Block className={className}>{rightBlock}</Block>
                )}
            </StyledResponsiveContainer>
        )
    }
}

const StyledResponsiveContainer = styled(ResponsiveContainer)`
    margin: 50px auto 20px;
    width: 100%;
    &.ecomm-kingdom {
        margin-top: 20px;
    }
`

const SwitchContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    ${media.medium`
        justify-content: flex-start;
        &.ecomm-kingdom,
        &.dashboard {
            width: 75%;
            justify-content: center;
            margin-left: -50px;
            ${props => props.right && `width: 105%`}
        }
        &.ecomm-kingdom {
            width: 105%;
        }
    `};
    ${media.large`
        &.ecomm-kingdom,
        &.dashboard {
            justify-content: center;
            margin-left: 8%;
            ${props => props.right && `width: 75%`}
        }
        &.ecomm-kingdom {
            width: 75%;
        }
    `}
`

const Block = styled.div`
    border-radius: 12px;
    width: 100%;
    background: white;
    &.ecomm-kingdom {
        background: ${tertiary};
    }
`

export { SplitLayout }
